import { useMemo } from 'react';
import { useTravelPlacesPricingAndBookingDetailsFragment } from '@shared/hooks/useTravelPlacesPricingAndBookingDetails';
import { useTravelPlacesPriceComparisonFragment } from '@shared/hooks/useTravelPlacesPriceComparison';
import { useMinimumPercentageOffToDisplay } from '@shared/hooks/useMinimumPercentageOffToDisplay';
import { getPercentageOff } from '@shared/utils/accommodationPrice';
import { AccommodationCombined } from '../../../Accommodations/Accommodation.types';
import { Discount } from '@shared/components/DiscountsProvider/DiscountsProviderTypes';

export const useJoyPlacePricingV2PriceInfo = (accommodation?: AccommodationCombined, skip?: boolean, discount?: Discount) => {
  const { minimumPercentageOffToDisplayValue, loadingMinimumPercentageOffToDisplay } = useMinimumPercentageOffToDisplay();

  const {
    price,
    loading: isTravelPlacesPricingAndBookingLoading,
    data,
    soldOutUrl,
    originalPrice,
  } = useTravelPlacesPricingAndBookingDetailsFragment(accommodation?.id, 'accommodationPlace', undefined, discount);

  const priceData = data?.pricingInfo?.nightlyBaseRate;
  const priceMinorUnits = priceData?.valueInMinorUnits;
  const priceMinorUnitsDigits = priceData?.digits;

  const { rates, loading: isPriceComparisonLoading } = useTravelPlacesPriceComparisonFragment(accommodation?.joyPlaceId || '', !accommodation?.joyPlaceId || skip);

  const highestPriceFromRates = useMemo(() => [...rates].sort((a, b) => b.priceInMinorUnits - a.priceInMinorUnits)[0], [rates]);

  const percentageOff = useMemo(
    () =>
      getPercentageOff(minimumPercentageOffToDisplayValue, priceMinorUnits, highestPriceFromRates?.priceInMinorUnits, priceMinorUnitsDigits, highestPriceFromRates?.priceDigits),
    [highestPriceFromRates?.priceDigits, highestPriceFromRates?.priceInMinorUnits, minimumPercentageOffToDisplayValue, priceMinorUnits, priceMinorUnitsDigits],
  );

  const loading = loadingMinimumPercentageOffToDisplay || isTravelPlacesPricingAndBookingLoading || isPriceComparisonLoading;

  return { rates, price, priceData, percentageOff, loading, soldOutUrl, originalPrice };
};
